const chat = {
  composer: {
    inputAriaLabel: 'Champ de message',
    placeholder: 'Posez une question sur les tendances de sécurité, les conducteurs et les incidents... saisissez \'help\' pour obtenir de l\'aide.',
    sendMessage: 'Envoyer le message',
  },
  copyMarkdown: {
    action: 'Copier le Markdown',
    copied: 'Copié',
    title: 'Copier le Markdown brut dans le presse-papiers',
  },
  citations: {
    summary_one: 'Source de données ({{count}})',
    summary_other: 'Sources de données ({{count}})',
  },
  errors: {
    authenticationFailed: "Échec de l'authentification. Veuillez vous reconnecter.",
    authenticationHint: 'Vérifiez vos identifiants de connexion et réessayez.',
    dismiss: "Fermer l'erreur",
    loginRequired: 'Connectez-vous pour envoyer des messages.',
    messageWithHint: '{{message}}\n\n**Conseil :** {{hint}}',
    networkFailed: 'Échec de la connexion réseau. Vérifiez votre connexion Internet et réessayez.',
    networkHint: 'Vérifiez que votre connexion Internet est stable et que le serveur SpeedGauge est accessible.',
    requestFailed: "Impossible d'envoyer votre message. Réessayez.",
    serverHint: 'Le serveur peut être temporairement indisponible. Réessayez dans quelques instants.',
    sessionCreating: 'Votre session est en cours de création. Attendez un moment et réessayez.',
    sessionExpired: "Votre session a expiré en raison de l'inactivité. Veuillez vous reconnecter pour continuer.",
    sessionExpiredHint: "Votre session a expiré après 24 heures d'inactivité. C'est normal pour des raisons de sécurité.",
  },
  feedback: {
    cancel: 'Annuler',
    characterCount: '{{count}} / {{maximum}}',
    close: 'Fermer la fenêtre de commentaires',
    commentTooLong_one: 'Les commentaires doivent contenir {{formattedMaximum}} caractères ou moins. Supprimez {{formattedCount}} caractère.',
    commentTooLong_other: 'Les commentaires doivent contenir {{formattedMaximum}} caractères ou moins. Supprimez {{formattedCount}} caractères.',
    commentsLabel: 'Commentaires supplémentaires (facultatifs)',
    commentsPlaceholder: 'Partagez tout commentaire précis pour nous aider à nous améliorer...',
    helpful: 'Utile',
    helpfulAriaLabel: 'Pouce vers le haut - Utile',
    helpfulTitle: 'Cette réponse était utile',
    notHelpful: 'Peu utile',
    notHelpfulAriaLabel: 'Pouce vers le bas - Peu utile',
    notHelpfulTitle: "Cette réponse n'était pas utile",
    remainingCharacters_one: '{{count}} caractère restant',
    remainingCharacters_other: '{{count}} caractères restants',
    ratingQuestion: 'Comment évaluez-vous cette réponse ?',
    reduceToSubmit: 'Réduisez la longueur des commentaires pour les envoyer',
    submit: 'Envoyer les commentaires',
    submitFailed: "Impossible d'envoyer les commentaires. Réessayez.",
    submitting: 'Envoi en cours...',
    title: 'Commentaires sur le message',
  },
  history: {
    cancelDelete: 'Annuler',
    close: 'Fermer',
    closeTitle: 'Fermer la session',
    confirmDelete: 'Confirmer',
    confirmDeleteTitle: 'Confirmer la suppression',
    delete: 'Supprimer la session',
    deleteFailed: 'Impossible de supprimer cette session. Réessayez.',
    deleteTitle: 'Supprimer la session',
    empty: 'Aucun historique de chat pour le moment',
    invalidDate: 'Date non valide',
    invalidTime: 'Heure non valide',
    loading: 'Chargement...',
    loadingChat: 'Chargement du chat',
    showMore: 'Afficher plus',
  },
  messageList: {
    ariaLabel: 'Messages de chat',
  },
  map: {
    loading: 'Chargement de la carte...',
  },
  messages: {
    ariaLabel: 'Message de {{role}}',
    assistant: 'assistant',
    user: 'utilisateur',
    you: 'Vous',
  },
  status: {
    initializing: 'Initialisation...',
    initializingAriaLabel: 'Initialisation du chat',
    thinking: 'Réflexion...',
    thinkingAriaLabel: "L'assistant réfléchit",
  },
  suggestions: {
    ariaLabel: 'Suggestions du Coach',
    generatedAriaLabel: 'Suggestions de suivi générées',
    empty: "Aucune suggestion du Coach n'est disponible pour le moment.",
    loading: 'Chargement des suggestions du Coach...',
    rightPanel: 'Demandez au Coach',
    send: 'Envoyer {{title}}',
    unavailable: 'Les suggestions du Coach sont temporairement indisponibles.',
  },
  streamEvents: {
    complete: 'Terminé',
    event: 'Événement',
    latest: 'Dernier événement : {{label}}',
    reasoning: 'Raisonnement',
    response: 'Réponse commencée',
    sessionDocument: 'Document de session',
    streamingResponse: 'Réponse en cours',
    toolUse: "Utilisation d'un outil",
    toolUseWithName: "Utilisation de l'outil : {{name}}",
    toolResult: "Résultat de l'outil",
    toolResultWithName: "Résultat de l'outil : {{name}}",
    update: 'Mise à jour',
  },
  welcome: {
    newUser: 'Bonjour ! Je suis SpeedGauge Coach AI.\n\nComment puis-je vous aider ?',
    returning: {
      driverData: 'Bon retour ! Prêt à analyser les données de vos conducteurs ?',
      explore: 'Ravi de vous revoir ! Que souhaitez-vous explorer ?',
      goodToSeeYou: 'Heureux de vous revoir ! Comment puis-je vous aider ?',
      helloAgain: 'Bonjour à nouveau ! Comment puis-je vous aider ?',
      insights: 'Bon retour ! Quelles informations puis-je vous aider à découvrir ?',
      readyToHelp: "Bonjour ! Que puis-je faire pour vous aujourd'hui ?",
      welcome: 'Bienvenue ! Que souhaitez-vous savoir ?',
      welcomeBack: "Bon retour ! Comment puis-je vous aider aujourd'hui ?",
    },
  },
} as const;

export default chat;